import { Component, Input, OnInit } from '@angular/core';
import { handleRatio } from 'src/app/_classes';
import { GeneratedTimelineCardData } from 'src/app/_interfaces';
import { TournamentSearchCardComponent } from '../tournament-search-card/tournament-search-card.component';
import { LiveEntriesComponent } from './live-entries/live-entries.component';
import { CollectionEntriesComponent } from './collection-entries/collection-entries.component';

@Component({
    selector: 'app-timeline-schedule-entry',
    templateUrl: './timeline-schedule-entry.component.html',
    styleUrls: ['./timeline-schedule-entry.component.scss'],
    imports: [TournamentSearchCardComponent, LiveEntriesComponent, CollectionEntriesComponent]
})
export class TimelineScheduleEntryComponent implements OnInit {
    @Input() timeline_id!: string;
    @Input() timeline_item!: GeneratedTimelineCardData;
    public aspect_ratio: string = '';

    constructor() { }

    ngOnInit(): void {
        this.aspect_ratio = handleRatio(this.timeline_item);
    }
}
